import React from "react";

const Copyright = () => {
  const style = {
    color: "white",
    // textAlign: "left",
    // textAlign: "center",
  };

  return <p style={style}>© Adebobola Oyedunmade 2025. All rights reserved</p>;
};

export default Copyright;
